import { RidangoReduxAction } from '@ridango/core';

import { PlannerStopsState, ResRobotStopLocation, ResRobotTrip } from '../../schedule.model';
import { PlannerActions } from './planner.action';

export const PLANNER_STATE_KEY = 'planner';

export interface PlannerState {
    origins: PlannerStopsState;
    destinations: PlannerStopsState;
    selectedOrigin: ResRobotStopLocation;
    selectedDestination: ResRobotStopLocation;
    trips: ResRobotTrip[];
    selectedTripId: number;
    loading: boolean;
    selectedDate: Date;
    selectedPriority: number;
}

export const PLANNER_INITIAL_STATE: PlannerState = {
    origins: { all: [], byId: {}, ids: [] },
    destinations: { all: [], byId: {}, ids: [] },
    selectedOrigin: null,
    selectedDestination: null,
    trips: null,
    selectedTripId: null,
    loading: false,
    selectedDate: null,
    selectedPriority: null,
};

export function plannerReducer(
    state: PlannerState = PLANNER_INITIAL_STATE,
    action: RidangoReduxAction
): PlannerState {
    switch (action.type) {
        case PlannerActions.FETCH_ORIGIN_LIST_SUCCESS:
            return {
                ...state,
                origins: action.payload,
            };
        case PlannerActions.FETCH_DESTINATION_LIST_SUCCESS:
            return {
                ...state,
                destinations: action.payload,
            };
        case PlannerActions.SET_ORIGIN:
            return {
                ...state,
                selectedOrigin: action.payload
            };
        case PlannerActions.SET_DESTINATION:
            return {
                ...state,
                selectedDestination: action.payload
            }
        case PlannerActions.FETCH_TRIP:
            return {
                ...state,
                loading: true
            };
        case PlannerActions.FETCH_TRIP_SUCCESS:
            return {
                ...state,
                trips: action.payload,
                selectedTripId: null,
                loading: false
            };
        case PlannerActions.FETCH_TRIP_FAIL:
            return {
                ...state,
                loading: false
            };
        case PlannerActions.SET_SELECTED_TRIP_ID:
            return {
                ...state,
                selectedTripId: action.payload
            };
        case PlannerActions.SET_SELECTED_DATE:
            return {
                ...state,
                selectedDate: action.payload
            };
        case PlannerActions.SET_SELECTED_PRIORITY:
            return {
                ...state,
                selectedPriority: action.payload
            };
        case PlannerActions.RESET_TRIPS:
            return {
                ...state,
                trips: null,
                selectedTripId: null
            };
        case PlannerActions.RESET_PLANNER:
            return {
                ...state,
                origins: { all: [], byId: {}, ids: [] },
                destinations: { all: [], byId: {}, ids: [] },
                selectedOrigin: null,
                selectedDestination: null,
                trips: null,
                selectedTripId: null,
                loading: false,
                selectedDate: null,
                selectedPriority: null,
            };
    }

    return state;
}
